import type { LucideIcon } from "lucide-react";

export type QuickAddTone = "brand" | "revenue" | "expense" | "focus" | "neutral";

export interface QuickAddAction {
  id: string;
  label: string;
  icon: LucideIcon;
  onClick: () => void;
  tone?: QuickAddTone;
}

const toneClasses: Record<QuickAddTone, string> = {
  brand: "bg-brand/15 text-brand ring-brand/25 hover:bg-brand/20",
  revenue: "bg-revenue/15 text-revenue ring-revenue/25 hover:bg-revenue/20",
  expense: "bg-expense/15 text-expense ring-expense/25 hover:bg-expense/20",
  focus: "bg-focus/15 text-focus ring-focus/25 hover:bg-focus/20",
  neutral: "bg-white/5 text-white/75 ring-white/10 hover:bg-white/10",
};

export function QuickAddBar({ actions }: { actions: QuickAddAction[] }) {
  return (
    <div className="flex flex-wrap gap-2">
      {actions.map((action) => {
        const Icon = action.icon;
        const tone = action.tone ?? "neutral";
        return (
          <button
            key={action.id}
            type="button"
            onClick={action.onClick}
            className={`inline-flex items-center gap-2 rounded-[14px] px-3 py-2 text-sm font-semibold ring-1 transition-colors ${toneClasses[tone]}`}
          >
            <Icon className="h-4 w-4 shrink-0" />
            {action.label}
          </button>
        );
      })}
    </div>
  );
}
